import { TopNavButtonsWrapperUnstyled } from 'Components/Header/TopNavButtonsWrapper/unstyled'
import styled from 'styled-components'

export const TopNavButtonsWrapper = styled(TopNavButtonsWrapperUnstyled)`
  display: inline-block;
  position: relative;
  max-height: 100%;
  vertical-align: top;

  ul {
    display: inline-block;
    list-style: none;
    margin: 0;
    padding: 0;
    height: 100%;
    white-space: nowrap;
  }

  .opacity-background {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: ${props => props.theme.colors.secondary};
    opacity: 0.2;
  }
`
